export default __webpack_public_path__ + "static/media/indicinaLogo.ecf1ee80.png";